import Vue from 'vue'
import VueRouter from 'vue-router'

// 全局处理重复导航错误
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    meta: {
      title: '首页',
      keywords: '青山新材料',
      description: '首页'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: {
      title: '首页',
      keywords: '青山新材料',
      description: '首页'
    }
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('../views/ProductsView.vue'),
    meta: {
      title: '首页',
      keywords: '青山新材料',
      description: '首页'
    }
  },
  {
    path: '/cases',
    name: 'cases',
    component: () => import('../views/CasesView.vue'),
    meta: {
      title: '首页',
      keywords: '青山新材料',
      description: '首页'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue'),
    meta: {
      title: '首页',
      keywords: '青山新材料',
      description: '首页'
    }
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: () => import('../views/ProductDetail.vue'),
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // 添加滚动行为控制
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（浏览器前进/后退）
    if (savedPosition) {
      return savedPosition
    }
    // 如果路由中有 hash，滚动到对应的锚点
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    }
    // 默认滚动到顶部
    return { x: 0, y: 0 }
  }
})

export default router
